<template lang="pug">
include index.pug
</template>

<script>
import Error from './error'
import Forbidden from './forbidden'
import OpenOnMobile from './openOnMobile'
import GdprAccept from './gdpr'
import services from '@/services'
import { createNamespacedHelpers } from 'vuex'
import { actionTypes as globalActionTypes } from '@/store/globals/actions'
import ageUtils from '@/utils/ageUtils'
import { ApplicationTypes, MinimumAges } from '@/models'
import RouteNames from '@/models/routes'

const globalStore = createNamespacedHelpers('globals')
const applicationStore = createNamespacedHelpers('application')
const oidcStore = createNamespacedHelpers('oidc')

export default {
  name: 'MunicipalityView',
  components: {
    Error,
    Forbidden,
    OpenOnMobile,
    GdprAccept
  },
  computed: {
    ...globalStore.mapState({
      error: (state) => state.error,
      gdprStatus: (state) => state.gdprStatus
    }),
    ...applicationStore.mapState({
      applicationId: (state) => state.id
    }),
    ...oidcStore.mapGetters({
      isAuthenticated: 'oidcIsAuthenticated',
      user: 'oidcUser'
    }),
    lowLoa: function () {
      return this.isAuthenticated && !JSON.parse(this.user.oiosaml_loa_valid.toLowerCase())
    },
    employyeLogin: function () {
      return this.isAuthenticated && this.user.oiosaml_profile_type == 'professional'
    },
    minimumAge: function () {
      const minAge = this.$route.meta.minAge
      if (minAge !== undefined) {
        return typeof minAge === 'number' ? { years: minAge } : minAge
      }
      if (this.$route.params.applicationType) {
        return this.$route.params.applicationType === ApplicationTypes.Passport ? MinimumAges.Adult : MinimumAges.DrivingLicenseApplication
      }
      return this.$route.name === RouteNames.Landing ? MinimumAges.DrivingLicenseApplication : MinimumAges.Adult
    },
    childLogin: function () {
      return this.isAuthenticated && !ageUtils.hasReachedAge(this.user.cpr_number, this.minimumAge)
    },
    childLoginMessage: function () {
      if (this.minimumAge === MinimumAges.Adult) {
        return 'For selv at søge om pas skal du være fyldt 18 år. Er du under 18 år skal dine forældre udfylde ansøgningen.'
      }
      if (this.minimumAge === MinimumAges.DrivingLicenseApplication) {
        return 'Du kan tidligst bruge denne løsning 3 måneder før du fylder 17 år.'
      }
      return `Du skal være fyldt ${this.minimumAge.years} år for at bruge denne løsning. Er du under ${this.minimumAge.years} år skal dine forældre logge ind.`
    },
    validLogin: function () {
      return this.isAuthenticated && !this.lowLoa && !this.employyeLogin && !this.childLogin
    },
    requiresMobile: function () {
      return this.$route.meta.requiresMobile && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
    requiredGdprAcceptance: function () {
      return this.validLogin && this.$route.meta.requiresGDPR && !this.gdprStatus
    }
  },
  watch: {
    async $route(to) {
      if (to.meta.requiresHubConnection && this.applicationId) {
        await services.hub.initialize()
      }
    }
  },
  mounted() {
    this.loadTexts()

    if (this.$route.meta.requiresHubConnection && this.applicationId && !this.requiresMobile) {
      services.hub.initialize()
    }
  },
  methods: {
    ...globalStore.mapActions({
      loadTexts: globalActionTypes.LOAD_TEXTS
    })
  }
}
</script>
